import axios from '../../utils/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { apiEndpoint } from '../../utils/apiEndpointUtility';

import {
	createAccount,
	createAccountCompleted,
	createAccountFailed
} from './createAccountSlice';

export const createAccountEpic = (action$) =>
	action$.pipe(
		ofType(createAccount),
		mergeMap(async (action) => {
			try {
				const accountInfo = action.payload;

				const response = await axios.post(
					`${apiEndpoint()}/api/v2/checkout`,
					accountInfo
				);

				if (response.status !== 200) {
					throw new Error(response.data);
				}
				return response.data;
			} catch (e) {
				throw e;
			}
		}),
		switchMap((response) => [createAccountCompleted(response)]),
		catchError((error, source) =>
			merge(of(createAccountFailed(error.message)), source)
		)
	);

export default [createAccountEpic];
